import { RoleResponseModel } from "../../../_core/_model";
import { getAPIUrl } from "../../../Constants.ts";
import axios from 'axios';

const API_URL = getAPIUrl();

const SAVE_ROLE = `${API_URL}/values/UpsertRoles`;

export function SaveRole(request: RoleResponseModel) {
    return axios.post<string>(SAVE_ROLE, request);
}